import { Category } from 'src/interfaces/category.model';

/** «Новинки» — блок позиций с маркером premiere наверху меню (мобильная и десктоп-вёрстка) */
export const PREMIERE_CATEGORY: Category = {
  id: 'id-premiere-category',
  title: 'Новинки',
  active: true,
  languages: new Map([
    ['en', 'New'],
    ['de', 'Neuheiten'],
    ['fr', 'Nouveautés'],
    ['ru', 'Новинки'],
    ['ua', 'Новинки'],
    ['it', 'Nuovo'],
    ['es', 'Nuevo'],
    ['pl', 'Nowe'],
    ['zh', '最新'],
    ['nl', 'Nieuw'],
    ['pt', 'Novo'],
    ['sv', 'Ny'],
    ['tr', 'Yeni'],
    ['ar', 'جديد'],
    ['ja', '新しい'],
    ['sr', 'Novo'],
  ]),
  index: 0,
};
